import { jsx as _jsx } from "react/jsx-runtime";
import { FieldViewType } from "../viewType";
import BaseFieldDetail from "../base/detail";
/** <b>Composant en mode consultation/detail d'un champ de type base</b>*/
export default function NameFieldDetail(_a) {
    var fieldName = _a.fieldName, record = _a.record, fieldMetadata = _a.fieldMetadata;
    return (_jsx(BaseFieldDetail, { viewType: FieldViewType.DETAIL, fieldName: fieldName, record: record }));
}
